module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_NB2-p35_Oct1958.67ab0cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_NB2-p35_Oct1958.jpg
// module id = k35/
// module chunks = 0